<template>
  <v-container fluid>
    <v-card flat color="background">
      <v-card-title primary-title>Add Or Remove A Location From Current Group</v-card-title>
      <v-card-subtitle>To add a location to current group, turn the 'active' slider to right. Turn it to left to remove.</v-card-subtitle>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field v-model="search" prepend-inner-icon="search" label="Search Locations"></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-checkbox v-model="showActiveGroupsOnly" label="Show active locations only"></v-checkbox>
          </v-col>
        </v-row>
        <v-data-table
          :search="search"
          class="background"
          :headers="headers"
          :items="filterdLocations"
        >
          <template v-slot:item.is_active="{ item }">
            <v-switch @change="handleToggle(item)" inset :label="item.is_active?'Active': 'Inactive'" v-model="item.is_active"></v-switch>
          </template>
          <template v-slot:item.go="{ item }">
            <v-btn @click="goToProfile(item)" fab small color="primary">
              <v-icon small>mdi-arrow-right</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { LocationGroupAPI } from '@/clients/locationGroups/locationGroups.api'
export default {
  mounted() {
    this.getLocationGroupDetails()
  },
  data() {
    return {
      showActiveGroupsOnly: true,
      search: '',
      group: null,
      headers: [{
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Address',
        value: 'address.formatted_address'
      },
      {
        text: 'Active',
        value: 'is_active'
      }, {
        text: 'Go ',
        value: 'go'
      }]
    }
  },
  methods: {
    async getLocationGroupDetails() {
      let response
      try {
        response = await LocationGroupAPI.getLocationGroupById(this.$route.params.id, true, true)
      } catch (error) {
        return console.log(error)
      }
      this.group = response.data.payload
    },
    goToProfile(location) {
      this.$router.push({ name: 'Profile_Store_Information', params: { id: location.id } })
    },
    async addLocationToGroup(location) {
      try {
        await LocationGroupAPI.addLocationToGroup(this.$route.params.id, location.id)
      } catch (error) {
        location.is_active = !location.is_active
        return console.log(error)
      }
      this.snackbar({ text: 'Location added to group successfully', color: 'success', icon: 'check' })
    },
    async removeLocationFromGroup(location) {
      try {
        await LocationGroupAPI.removeLocationFromAGroup(this.$route.params.id, location.id)
      } catch (error) {
        location.is_active = !location.is_active
        return console.log(error)
      }
      this.snackbar({ text: 'Location removed from the group', color: 'warning darken-1' })
    },
    handleToggle(location) {
      console.log(location)
      if (location.is_active) {
        this.addLocationToGroup(location)
      } else {
        this.removeLocationFromGroup(location)
      }
    }
  },
  computed: {
    filterdLocations() {
      if (this.group === null) return []
      if (this.showActiveGroupsOnly) {
        return this.group.locations.filter(i => i.is_active === true)
      }
      return this.group.locations
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
